<template>
  <base-button
    :inverse="!active"
    :style="styleText"
    :small="true"
    @click="onClick"
  >
    <fa-icon
      icon="star"
    />
    <span>Agregar a Favoritos</span>
  </base-button>
</template>
<script>
export default {
    name: 'StarButton',
    props: {
        active: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return { };
    },
    computed: {
        styleText() {
            if (this.onMobile()) {
                return 'font-size: 12px; border-radius: 10px; padding: 0px;';
            }
            return 'font-size: 13px; border-radius: 10px;';
        },
    },
    methods: {
        onMobile() {
            return window.innerWidth <= 400;
        },
        onClick() {
            // this.active = !this.active;
            this.$emit('input', this.active);
        },
    },
};
</script>
<style lang="scss">
  @import "../scss/style";
  .star-button{
    cursor: pointer;
  }
</style>
